import { render, staticRenderFns } from "./player.vue?vue&type=template&id=bc7dc302&scoped=true&"
import script from "./player.vue?vue&type=script&lang=js&"
export * from "./player.vue?vue&type=script&lang=js&"
import style0 from "./player.vue?vue&type=style&index=0&id=bc7dc302&lang=less&scoped=true&"
import style1 from "./player.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7dc302",
  null
  
)

export default component.exports